/**
 * Quem cuida de cada endereco fora da pagina inicial. O cardapio publico mora
 * em /<slug>; login, cadastro, painel e portal tem nomes fixos, que o backend
 * reserva (SLUGS_RESERVADOS em backend/src/empresas/regras.ts) para nenhum
 * restaurante usar. Fica fora dos dois pedacos lazy para decidir sem baixar
 * nenhum deles.
 */
export const AREAS_LOGIN = new Set(['login', 'cadastro', 'painel', 'portal'])

// Mesmo formato do slug no backend.
const SLUG_OK = /^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/

export function ehCardapio(caminho: string): boolean {
  const primeiro = caminho.split('/')[1] ?? ''
  return !AREAS_LOGIN.has(primeiro) && SLUG_OK.test(primeiro) && !primeiro.includes('--')
}
